import TransferList, { TransferListCategoryOption } from 'src/components/TransferList';
import useViewDepartments from 'src/hooks/useViewDepartments';

export const categories: TransferListCategoryOption[] = [
  { value: 0, label: 'Show All', filters: [] },
  {
    value: 1,
    label: 'Show Active/Inactive',
    filters: [{ operator: 'neq', field: 'isDeleted', value: true }],
  },
  {
    value: 2,
    label: 'Show Disabled',
    filters: [{ operator: 'eq', field: 'isDeleted', value: true }],
  },
];

const AssignMembers = () => {
  const {
    unassignedMembers,
    setUnassignedMembers,
    assignedMembers,
    setAssignedMembers,
    bulkAssignRefresher,
  } = useViewDepartments();

  return (
    <TransferList
      leftList={unassignedMembers}
      rightList={assignedMembers}
      title="Department Members"
      leftListTitle="Unassigned Department Members"
      rightListTitle="Assigned Department Members"
      searchPlaceholder="Filter by name..."
      setLeftList={setUnassignedMembers}
      setRightList={setAssignedMembers}
      height="calc(100vh - 280px)"
      categories={categories}
      label="member(s)"
      deletedItemLabel="(disabled)"
      bulkAssignRefresher={bulkAssignRefresher}
    />
  );
};

export default AssignMembers;
